export default "__VITE_ASSET__ymqzsrpb__"